import React from 'react';

export default function Processus() {
  return (
    <>
        {/* Process Start */}


<div className="container-xxl py-5">
  <div className="container">
    <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
      <h6 className="bg-white text-center px-3" style={{ color: '#00338C', borderColor: '#01225C' , fontSize: '28px' , fontWeight:'500' }}>
        Processus
      </h6>
      <h1 className="mb-5" style={{ color: '#01225C' , fontSize:'48px' }}>Des étapes Faciles</h1>
    </div>

    <div className="position-relative mt-4">
      {/* Ligne horizontale jaune de fond */}
      <div 
        className="d-none d-lg-block position-absolute" 
        style={{
          top: '50px', 
          left: '10%', 
          right: '10%', 
          height: '2px', 
          backgroundColor: '#FFBC1E',
          zIndex: 0
        }}
      ></div>

      <div className="row gy-4 position-relative" style={{ zIndex: 1 }}>
        {/* Step 1 */}
        <div className="col-lg wow d-flex flex-column fadeInUp" data-wow-delay="0.1s">
          <div className="text-center mb-3">
            <div 
              className="d-inline-flex align-items-center justify-content-center text-white" 
              style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#00338C', fontSize: '1.25rem', fontWeight: 'bold', border: '3px solid white' }}
            >
              1
            </div>
          </div>
          <div className="text-center p-4 bg-white d-flex flex-column justify-content-center flex-grow-1" style={{ border:"1px solid #ACCBFF", borderRadius: "10px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
            <h5 className="mb-2" style={{ color: '#00338C', fontSize: '1.1rem', fontWeight: 'bold' }}>Choisir Le Programme</h5>
            <p className="mb-0 " style={{ fontSize: '0.9rem' , color: '#00338C' }}>Sélectionnez votre destination de rêve</p>
          </div>
        </div>

        {/* Step 2 */}
        <div className="col-lg wow d-flex flex-column fadeInUp" data-wow-delay="0.2s">
          <div className="text-center mb-3">
            <div 
              className="d-inline-flex align-items-center justify-content-center text-white" 
              style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#00338C', fontSize: '1.25rem', fontWeight: 'bold', border: '3px solid white' }}
            >
              2
            </div>
          </div>
          <div className="text-center p-4 bg-white d-flex flex-column justify-content-center flex-grow-1" style={{ border:"1px solid #ACCBFF", borderRadius: "10px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
            <h5 className="mb-2" style={{ color: '#00338C', fontSize: '1.1rem', fontWeight: 'bold' }}>Remplir Les Détails</h5>
            <p className="mb-0 " style={{ fontSize: '0.9rem' , color: '#00338C' }}>Date, type de chambre, nombre de personnes</p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="col-lg wow d-flex flex-column fadeInUp" data-wow-delay="0.3s">
          <div className="text-center mb-3">
            <div 
              className="d-inline-flex align-items-center justify-content-center text-white" 
              style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#00338C', fontSize: '1.25rem', fontWeight: 'bold', border: '3px solid white' }}
            >
              3
            </div>
            </div>
          <div className="text-center p-4 bg-white d-flex flex-column justify-content-center flex-grow-1" style={{ border:"1px solid #ACCBFF", borderRadius: "10px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
            <h5 className="mb-2" style={{ color: '#00338C', fontSize: '1.1rem', fontWeight: 'bold' }}>Confirmer La Commande</h5>
            <p className="mb-0 " style={{ fontSize: '0.9rem' , color: '#00338C'}}>Recevez votre devis détaillé</p>
          </div>
        </div>

        {/* Step 4 */}
        <div className="col-lg wow d-flex flex-column fadeInUp" data-wow-delay="0.4s">
          <div className="text-center mb-3">
            <div 
              className="d-inline-flex align-items-center justify-content-center text-white" 
              style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#00338C', fontSize: '1.25rem', fontWeight: 'bold', border: '3px solid white' }}
            >
              4
            </div>
          </div>
          <div className="text-center p-4 bg-white d-flex flex-column justify-content-center flex-grow-1" style={{ border:"1px solid #ACCBFF", borderRadius: "10px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
            <h5 className="mb-2" style={{ color: '#00338C', fontSize: '1.1rem', fontWeight: 'bold' }}>Fiche Client</h5>
            <p className="mb-0 " style={{ fontSize: '0.9rem' , color: '#00338C' }}>Remplissez vos coordonnées personnelles</p>
          </div>
        </div>

        {/* Step 5 */}
        <div className="col-lg wow d-flex flex-column fadeInUp" data-wow-delay="0.5s">
          <div className="text-center mb-3">
            <div 
              className="d-inline-flex align-items-center justify-content-center text-white" 
              style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#00338C', fontSize: '1.25rem', fontWeight: 'bold', border: '3px solid white' }}
            >
              5
            </div>
          </div>
          <div className="text-center p-4 bg-white d-flex flex-column justify-content-center flex-grow-1" style={{ border:"1px solid #ACCBFF", borderRadius: "10px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
            <h5 className="mb-2" style={{ color: '#00338C', fontSize: '1.1rem', fontWeight: 'bold' }}>Bon De Commande</h5>
            <p className="mb-0" style={{ fontSize: '0.9rem' , color: '#00338C' }}>Recevez et validez votre bon de commande</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


        {/* Process End */}
    </>
  );
}
